/* ============================================================================
   גרירה בעכבר על סליידר הבאנרים בדף הבית. נוצר 01.09.2026, בקשת יובל.

   📌 ההחלקה באצבע אינה כאן, והיא כולה CSS. ברגע ש-overflow-x חזר ל-auto
   הגולל הטבעי של הדפדפן מטפל במגע, כולל תאוצה והצמדה. אין טעם ליירט מגע,
   ויירוט כזה דווקא היה שובר את התאוצה.

   🔴 למה בכלל צריך קוד: לגולל טבעי אין גרירה בעכבר בשום דפדפן. קוד גרירה
   כבר קיים בתמה (global.js:1606), אבל הוא מותנה ב-this.scrollTrack, שהוא
   .slider-scrollbar__track. לסליידר הבאנרים אין כזה, ולכן הוא לעולם אינו
   נקשר. נמדד ולא הונח: hasScrollTrack היה false.

   📌 השתלבות בתמה, בלי לגעת בה: SliderComponent מאזין תמיד ל-scroll
   (global.js:1592) ומעדכן ממנו את השקופית הנוכחית. לכן גרירה מסנכרנת מעצמה
   את המונה, את החצים ואת נקודת ההמשך של האוטומט. אין צורך לעדכן שום מצב פנימי.
   ============================================================================ */

(function () {
  'use strict';

  var SELECTOR = '[id^="Slider-"][id*="__banners_slideshow"]';
  var THRESHOLD = 5;      // פיקסלים. מתחת לזה זו לחיצה ולא גרירה.

  function init(slider) {
    if (!slider || slider.dataset.tyDragBound === '1') return;
    slider.dataset.tyDragBound = '1';

    var component = slider.closest('slideshow-component');
    var down = false, dragged = false, startX = 0, startScroll = 0, wasPaused = false;

    slider.addEventListener('pointerdown', function (e) {
      // מגע ועט מטופלים בגולל הטבעי. יירוט שלהם שובר את התאוצה.
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true;
      dragged = false;
      startX = e.clientX;
      startScroll = slider.scrollLeft;

      /* עוצרים את האוטומט לזמן התנועה בלבד. בלי זה הוא קופץ באמצע הגרירה
         ומושך את הסליידר מתחת ליד. הכרעת יובל: האוטומט ממשיך כרגיל אחרי. */
      wasPaused = component ? component.getAttribute('data-paused') === 'true' : true;
      if (component && !wasPaused && typeof component.pause === 'function') component.pause();
    });

    slider.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!dragged) {
        if (Math.abs(dx) < THRESHOLD) return;
        dragged = true;
        slider.classList.add('ty-drag');
        // מרגע התפיסה כל תנועה מגיעה אלינו, גם אם העכבר יצא מהסליידר
        if (slider.setPointerCapture) { try { slider.setPointerCapture(e.pointerId); } catch (err) {} }
      }
      e.preventDefault();
      slider.scrollLeft = startScroll - dx;
    });

    function release(e) {
      if (!down) return;
      down = false;
      if (slider.releasePointerCapture && e && e.pointerId != null) {
        try { slider.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      if (dragged) {
        /* 🔴 מבטלים את הלחיצה שמגיעה מיד אחרי הגרירה, אחרת שחרור העכבר
           מנווט למוצר של השקופית. שלב הלכידה, אחרת הקישור מקבל אותה קודם. */
        slider.addEventListener('click', function kill(ev) {
          ev.preventDefault(); ev.stopPropagation();
        }, { capture: true, once: true });
        slider.classList.remove('ty-drag');
        snap();
      }
      if (component && !wasPaused && typeof component.play === 'function') component.play();
    }

    slider.addEventListener('pointerup', release);
    slider.addEventListener('pointercancel', release);
    slider.addEventListener('dragstart', function (e) { if (dragged) e.preventDefault(); });

    /* מצמידים לשקופית הקרובה.
       🔴 זה נדרש גם אחרי החלקה באצבע, ולא רק אחרי גרירה בעכבר. נמדד:
       החלקה של 260 פיקסל במסך 390 נחה על 260 **ונשארה שם**, כלומר שתי
       חצאי שקופיות זו לצד זו. ‏scroll-snap-type: x mandatory מוגדר על
       הסליידר ולא הספיק. ⟹ מצמידים בקוד ולא סומכים על ה-CSS לבדו. */
    function snap() {
      var slides = slider.querySelectorAll('[id^="Slide-"], [data-ty-clone]'); // ty-slideshow-loop: גם העותקים
      if (slides.length < 2) return;
      var base = slider.getBoundingClientRect().left, best = null, bestD = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(slides[i].getBoundingClientRect().left - base);
        if (d < bestD) { bestD = d; best = slides[i]; }
      }
      if (!best || bestD < 2) return;              // כבר על גבול, אין מה לעשות
      slider.scrollBy({ left: best.getBoundingClientRect().left - base, behavior: 'smooth' });
    }

    /* מצמידים בכל פעם שהגלילה נחה, מאיזו סיבה שלא תהיה: אצבע, גלגלת, או
       מקלדת. ‏160ms אחרי אירוע הגלילה האחרון, כלומר רק במנוחה.
       📌 אינו נלחם באוטומט: הוא נוחת בדיוק על גבול שקופית, ואז snap אינו עושה כלום. */
    var restTimer = null;
    slider.addEventListener('scroll', function () {
      if (down) return;                            // באמצע גרירה בעכבר
      clearTimeout(restTimer);
      restTimer = setTimeout(snap, 160);
    }, { passive: true });
  }

  function boot() {
    var list = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // עורך התמה מרנדר את הסקשן מחדש, והמאזינים הולכים איתו
  document.addEventListener('shopify:section:load', boot);
})();
